export const ACCEPTED_FILE_TYPES_FOR_ID_CERTIFICATION_FORM = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  ".pcx",
  "image/bmp",
];

export const ID_CERTIFICATION_FORM_REQUIRED_COUNTRIES = ["PH"];
